var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_3200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66504 7.33154V11.3306",
    stroke: "#6A7282",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33105 7.33154V11.3306",
    stroke: "#6A7282",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6636 3.99902V13.3301C12.6636 13.6836 12.5231 14.0227 12.2731 14.2727C12.0232 14.5226 11.6841 14.6631 11.3306 14.6631H4.66553C4.31199 14.6631 3.97294 14.5226 3.72295 14.2727C3.47296 14.0227 3.33252 13.6836 3.33252 13.3301V3.99902",
    stroke: "#6A7282",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 3.99902H13.9966",
    stroke: "#6A7282",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 3.99902V2.66602C5.33203 2.31248 5.47247 1.97342 5.72246 1.72344C5.97245 1.47345 6.3115 1.33301 6.66504 1.33301H9.33105C9.68459 1.33301 10.0236 1.47345 10.2736 1.72344C10.5236 1.97342 10.6641 2.31248 10.6641 2.66602V3.99902",
    stroke: "#6A7282",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_3200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9961,
    height: 15.9961,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.bf5ece0799350b88e635b9dd5837a61b.svg";
export { ForwardRef as ReactComponent };